import { ThemeColors } from 'app/providers/ThemeProvider';
import { CountryType } from 'entities/City';
import { NotifyLeaveDaysLimits } from 'entities/Contract';

import { PaymentMethod } from 'entities/Payment';

export interface AppSchema {
  loadingCount: number;
  globalSettings: Nullable<GlobalSettings>;
}

export enum Currencies {
  EUR = 'EUR',
  USD = 'USD',
  CHF = 'CHF',
  PLN = 'PLN',
  RUB = 'RUB',
}

export enum BookingDocumentsNames {
  PRIVACY_POLICY = 'Privacy Policy',
  RULES = 'Box usage rules',
  TERMS_AND_CONDITIONS = 'Terms & conditions',
  PERSONAL_DATA_AGREEMENT = 'Personal data Agreement',
  BOX_RENTAL_AGREEMENT = 'Box rental agreement',
}

export interface GlobalSettings {
  bankingRequisits: string;
  logoUrl: string;
  currency: Currencies;
  isBookingAvailiable: boolean;
  isDepositApplied: boolean;
  reservationPeriod: string;
  themeColors: ThemeColors;
  paymentMethods: string[];
  invoiceLeadDays: string;
  notifyLeaveDays: NotifyLeaveDaysLimits;
  bookingDocuments: Array<{ docName: string; link: string }>;
  country: CountryType;
  showGeneralPromotions: boolean;
  companyName: string;
  partnerKnowledgeBaseUrl: string;
  availableLanguages: string[];
  isStandaloneDeposit: boolean;
  arrivalDateLimit: number;
  publicPaymentMethods: Array<{ name: PaymentMethod; isAutoPaymentAllowed: boolean; imageUrl?: string }>;
  showPriceWithVat: boolean;
  isCustomerIdentificationNumberRequired: boolean;
  landingUrl: string;
}
